<template>
  <report
    :title="$t('language.officialvisitdetail')"
    :filter="filter"
    :url="url"
  >
    <template v-slot:filter>
      <v-flex xs12 sm6 md3>
        <ValidationProvider
          :name="$t('language.person')"
          rules="required"
          v-slot="{ errors }"
        >
          <v-autocomplete
            dense
            v-model="filter.personid"
            :items="PersonList"
            item-text="name"
            item-value="id"
            :label="$t('language.person')"
            :error-messages="errors[0]"
            :clearable="true"
          ></v-autocomplete>
        </ValidationProvider>
      </v-flex>
      <v-flex xs12 sm12 md3>
        <ValidationProvider
          :name="$t('language.attendanceyear')"
          rules="required"
          v-slot="{ errors }"
        >
          <v-autocomplete
            dense
            v-model="filter.attendanceyearid"
            :items="AttendanceYearList"
            item-text="name"
            item-value="id"
            :label="$t('language.attendanceyear')"
            :error-messages="errors[0]"
            :clearable="true"
          ></v-autocomplete>
        </ValidationProvider>
      </v-flex>
      <v-flex xs12 sm12 md3>
        <v-autocomplete
          dense
          v-model="filter.officialvisitid"
          :items="OfficialVisitList"
          item-text="name"
          item-value="id"
          :label="$t('language.officialvisit')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
    </template>
    <template v-slot:printheader>
      <table class="printheader">
        <tbody>
          <tr>
            <td>{{ $t("language.person") }}:{{ selectedperson }}</td>
            <td></td>
            <td>
              {{ $t("language.attendanceyear") }}:{{ selectedattendanceyear }}
            </td>
            <td></td>
            <td>
              {{ $t("language.officialvisit") }}:{{ selectedofficialvisit }}
            </td>
          </tr>
        </tbody>
      </table>
    </template>
    <template v-slot:table="{ data }">
      <table class="table table-bordered w-100">
        <thead>
          <tr>
            <th>{{ $t("language.officialvisit") }}</th>
            <th>{{ $t("language.fromdate") }}</th>
            <th>{{ $t("language.todate") }}</th>
            <th>{{ $t("language.taken") }}</th>
            <th>{{ $t("language.remarks") }}</th>
            <th>{{ $t("language.approver") }}</th>
            <th>{{ $t("language.approveddate") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="index">
            <td>{{ item.officialvisit }}</td>
            <td>{{ getDefaultDate(item.fromdate) }}</td>
            <td>{{ getDefaultDate(item.todate) }}</td>
            <td>{{ item.taken }}</td>
            <td>{{ item.remarks }}</td>
            <td>{{ item.approver }}</td>
            <td>{{ getDefaultDate(item.approveddate) }}</td>
          </tr>
        </tbody>
        <tfoot v-if="data.length == 0">
          <tr>
            <th colspan="7">{{ $t("language.nodatafound") }}</th>
          </tr>
        </tfoot>
      </table>
    </template>
  </report>
</template>
<script>
import axios from "axios";
import moment from "moment";
import Report from "../Report";
import commonservice from "../../../../shared/common.service";
export default {
  components: {
    Report,
  },
  data() {
    return {
      filter: {
        attendanceyearid: null,
        officialvisitid: null,
        personid: null,
      },
      AttendanceYearList: [],
      OfficialVisitList: [],
      PersonList: [],
      url: "client/report/officialvisit/details",
    };
  },
  computed: {
    selectedattendanceyear() {
      if (this.filter.attendanceyearid == null) return this.$t("language.all");
      return this.AttendanceYearList.filter((c) => {
        return c.id == this.filter.attendanceyearid;
      })[0].name;
    },
    selectedofficialvisit() {
      if (this.filter.officialvisitid == null) return this.$t("language.all");
      return this.OfficialVisitList.filter((c) => {
        return c.id == this.filter.officialvisitid;
      })[0].name;
    },
    selectedperson() {
      if (this.filter.personid == null) return this.$t("language.all");
      return this.PersonList.filter((c) => {
        return c.id == this.filter.personid;
      })[0].name;
    },
  },
  beforeRouteEnter(to, from, next) {
    axios.get("client/report/officialvisit/init/list").then((response) => {
      next((p) => {
        p.AttendanceYearList = response.data.attendanceyears;
        p.OfficialVisitList = response.data.officialvisits;
        p.PersonList = response.data.persons;
        let currendate = new Date();
        let current = p.AttendanceYearList.find(item=> new Date(item.startdate) <= currendate && new Date(item.enddate) >= currendate);
        if(current != null)
          p.filter.attendanceyearid = current.id;
      });
    });
  },
  methods: {
    getDefaultDate(date) {
      return commonservice.getDefaultDate(date);
    },
  },
};
</script>
